import { createActionGroup, emptyProps, props } from '@ngrx/store'
import { UploadAttachment } from '../models/attachments.model'
import {
  CatModelingWorkspaceFile,
  CatModelingFolderEntry,
} from 'src/app/cat-modeling/model/cat-modeling-workspace.model'
import {
  AttachmentMapping,
  Contact,
  DraftAndPortfolioData,
  EmailSendHeader,
  EmailTemplate,
  LayerQuoteDates,
  StructuresOverride,
  UpdateStructuresOverrideRequest,
} from '../models/draft-data.model'
import { MarketLayerMapping } from '../models/draft-selection.model'
import { LoadingBlock } from '../models/loading.model'
import { STMMarketOverride } from '../models/draft.model'
import {
  CodelistMapping,
  SageLinkPreviousMarkets,
  STMSageLinkDisplayResponse,
} from '../models/submit-to-market-sage-link.model'

export const SubmitToMarketLocalActions = createActionGroup({
  source: 'Local: Submit to Market',
  events: {
    'Draft Data Fetch Success': props<DraftAndPortfolioData>(),
    'Code Mapping List Fetch Success': props<{ data: CodelistMapping[] }>(),
    'Previous Markets Fetch Success': props<{ data: SageLinkPreviousMarkets[] }>(),
    'Stm Data Fetch Success': props<{ data: STMSageLinkDisplayResponse[] }>(),
    'Update STM Data Mapping': props<{ map: STMSageLinkDisplayResponse }>(),
    'Update Draft Selected Structures': props<{ selectedStructures: number[] }>(),
    'Clear Loaded State': emptyProps,
    'Update Draft Email Template': props<{ id: number; body?: string; name?: string }>(),
    'Update Draft Email Mappings': props<{ id: number; mapping: number[] }>(),
    'Update Market Layer Mappings': props<{ map: MarketLayerMapping[] }>(),
    'Update Market Layer Mapping': props<{ map: MarketLayerMapping }>(),
    'Update STM Data Mappings': props<{ map: STMSageLinkDisplayResponse[] }>(),
    'Update Attachment Mappings': props<{ map: AttachmentMapping[] }>(),
    'Update Dashboard Finality': props<{ programFactorId: number; status: boolean }>(),
    'Update Underwriter Team': props<{ programFactorId: number; underwriters: Contact[] }>(),
    'Set All Active Contacts': props<{ programFactorId: number; toggled: boolean }>(),
    'Update Dashboard Layer Date': props<{
      programFactorId: number
      layerId: string
      date: Date
    }>(),
    'Update Dashboard All Layer Dates': props<{
      programFactorId: number
      dates: LayerQuoteDates[]
    }>(),
    'Update Dashboard Email Subject': props<{ programFactorId: number; subject: string | null }>(),
    'Update Dashboard Custom Email Body': props<{ programFactorId: number; body: string | null }>(),
    'Set Dashboard As Custom Email': props<{
      programFactorId: number
      body: string | null
      currentHash: string | null
    }>(),
    'Update Dashboard Email Send Header': props<{
      programFactorId: number
      contact: Contact
      sendHeader?: EmailSendHeader
    }>(),
    'Add Email Template': props<{
      template: EmailTemplate
    }>(),
    'Update Dashboard Brokerage Team': props<{
      contacts: Contact[]
      programFactorIds: number[]
    }>(),
    'Update Dashboard Lead Market': props<{ programFactorId: number; leadMarket: string | null }>(),
    'Manually Add Contact': props<{ programFactorId: number; contact: Contact }>(),
    'Add Loading Block': props<LoadingBlock>(),
    'Clear Loading Block': props<{ id: number }>(),
    'Get All Brokers Success': props<{ brokers: Contact[] }>(),
    'Update Structures Override': props<{ override: StructuresOverride }>(),
    'Delete Structures Override': props<{ overrideId: number }>(),
    'Bulk Delete Structures Overrides': props<{ programFactorId: number }>(),
  },
})

export const SubmitToMarketServerActions = createActionGroup({
  source: 'Server: Submit to Market',
  events: {
    'Update Draft Selected Structures': emptyProps,
    'Update Draft Market Mapping': emptyProps,
    'Update Draft Market Overrides': props<{ overrides: STMMarketOverride[] }>(),
    'Update Draft Attachments Mappings': emptyProps,
    'Update Draft Dashboard': emptyProps,
    'Update Draft Email Templates': emptyProps,
    'Create Draft Email Template': emptyProps,
    'Finalize And Send': emptyProps,
    'Sage Link Finalize And Send ': emptyProps,
    'Upload Draft Attachments': props<{ attachments: UploadAttachment[] }>(),
    'Upload Cat Modeling Files As Attachments': props<{
      fileIdsToAttach: number[]
      fileIdsToDetach: number[]
    }>(),
    'Upload Cat Modeling Entries As Attachments': props<{
      entryIdsToAttach: number[]
      entryIdsToDetach: number[]
    }>(),
    'Upsert Structures Override': props<{
      draftId: number
      request: UpdateStructuresOverrideRequest
    }>(),
    'Delete Structures Override': props<{ draftId: number; overrideId: number }>(),
    'Bulk Delete Structures Overrides': props<{
      draftId: number
      programFactorId: number
      templateId: number
    }>(),
  },
})
